import styled from 'styled-components';
import { Text13Light } from '../../utils/Text/Text.styles';

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 1.2rem;
`;

export const Text = styled(Text13Light)``;
